export default __webpack_public_path__ + "media/images/manual/ic/12-8461a098b9eaa2233e1875736c07788d.png";